'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _toConsumableArray = _interopDefault(require('@babel/runtime/helpers/toConsumableArray'));
var _objectSpread = _interopDefault(require('@babel/runtime/helpers/objectSpread'));
var Vue = _interopDefault(require('vue'));
var getSystem = require('@mx/util/get-system');
var Tap = _interopDefault(require('../tap'));

/**
 * Register Tap
 */

Vue.use(Tap);
/**
 * Device Info
 */

var system = getSystem.getSystem();
var deviceInfo = {};

function onResize() {
  deviceInfo.winWidth = window.innerWidth;
  deviceInfo.winHeight = window.innerHeight;
}

if (system !== 'node') {
  onResize();
  window.addEventListener('resize', onResize);
}
/**
 * Create Component
 */


function create(options) {
  options.name = 'vix-' + options.name;

  options.install = function (Vue$$1) {
    Vue$$1.component(options.name, options);
  };

  return options;
}
/**
 * Create Simple Functional Component
 */

function createSimpleFC(options) {
  var _options$tag = options.tag,
      tag = _options$tag === void 0 ? 'div' : _options$tag,
      name = options.name,
      className = options.className,
      updateData = options.updateData;
  return create({
    name: name,
    functional: true,
    render: function render(createEL, ctx) {
      // 将 nativeOn 转化为 on
      if (ctx.data.nativeOn) {
        ctx.data.on = _objectSpread({}, ctx.data.on, ctx.data.nativeOn);
        delete ctx.data.nativeOn;
      }

      if (className) {
        mergeClass(ctx, className);
      }

      if (updateData) {
        updateData(ctx);
      }

      return createEL(tag, ctx.data, ctx.children);
    }
  });
} // 合并 class 对象

function mergeClass(ctx, className) {
  var data = ctx.data;

  if (typeof className === 'string') {
    data.staticClass = "".concat(data.staticClass || '', " ").concat(className);
  } else {
    data.class = _toConsumableArray(toArray(data.class)).concat(_toConsumableArray(toArray(className(ctx))));
  }
}

function toArray(item) {
  return item ? Array.isArray(item) ? item : [item] : [];
}

var hasProp = function hasProp(prop) {
  return prop || prop === '';
};
function sumOffsetTop(ele) {
  var top = 0;

  while (ele) {
    top += ele.offsetTop;
    ele = ele.offsetParent;
  }

  return top;
}

exports.deviceInfo = deviceInfo;
exports.create = create;
exports.createSimpleFC = createSimpleFC;
exports.hasProp = hasProp;
exports.sumOffsetTop = sumOffsetTop;
